import { useState } from "react";
import { C } from "../../styles/theme";
import { CASES } from "../../data/initialData";
import SecHdr from "../common/SecHdr";
import Dlg from "../common/Dlg";
import PBtn from "../common/PBtn";

export default function CaseStudies({ go }) {
  const [sel, setSel] = useState(null);
  return (
    <div className="section" style={{ background: C.bg }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <SecHdr tag="Case Studies" title="Proven Results for Our Clients" sub="Real projects, real outcomes across all four verticals." />
        <div className="grid-2">
          {CASES.map(c => (
            <div key={c.id} className="hl card" onClick={() => setSel(c)} style={{ padding: 0, cursor: "pointer", borderLeft: `4px solid ${c.color}`, borderTop: "none", borderRight: "none", borderBottom: "none", overflow: "hidden" }}>
              {c.image && <div style={{ position: "relative", height: 140, overflow: "hidden" }}><img src={c.image} alt={c.title} style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(.75)" }} onError={e => { e.target.style.display = "none"; }} /><div style={{ position: "absolute", inset: 0, background: `linear-gradient(135deg,${c.color}33,transparent)` }} /><span style={{ position: "absolute", top: 10, left: 14, background: "rgba(0,0,0,.45)", color: "#fff", fontSize: 10, fontWeight: 700, padding: "3px 9px", borderRadius: 20, letterSpacing: .5 }}>{c.sector}</span></div>}
              <div style={{ padding: "16px 18px 18px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 11, marginBottom: 12 }}>
                  <div style={{ width: 44, height: 44, borderRadius: 11, background: c.color + "18", border: `2px solid ${c.color}33`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{c.ic}</div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: c.color, textTransform: "uppercase", letterSpacing: .4 }}>{c.sector}</div>
                    <div style={{ fontSize: 14, fontWeight: 800, color: C.blue }}>{c.client}</div>
                  </div>
                </div>
                <h4 style={{ fontSize: 15, fontWeight: 700, color: C.dark, marginBottom: 8 }}>{c.title}</h4>
                <p style={{ fontSize: 13, color: C.gray, lineHeight: 1.65, marginBottom: 12 }}>{c.desc.slice(0, 120)}...</p>
                <div style={{ background: c.color + "0d", border: `1px solid ${c.color}33`, borderRadius: 8, padding: "8px 12px", fontSize: 12, color: c.color, fontWeight: 600 }}>{c.result}</div>
              </div>
            </div>
          ))}
        </div>
        {sel && (
          <Dlg title={"Case Study: " + sel.client} onClose={() => setSel(null)}>
            <div style={{ display: "flex", alignItems: "center", gap: 11, marginBottom: 14, paddingBottom: 12, borderBottom: `1px solid ${C.border}` }}>
              <div style={{ width: 46, height: 46, borderRadius: 11, background: sel.color + "18", border: `2px solid ${sel.color}33`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{sel.ic}</div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: sel.color, textTransform: "uppercase" }}>{sel.sector}</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: C.blue }}>{sel.title}</div>
              </div>
            </div>
            <p style={{ fontSize: 14, color: C.gray, lineHeight: 1.75, marginBottom: 14 }}>{sel.desc}</p>
            <div style={{ background: sel.color + "0d", border: `1px solid ${sel.color}33`, borderRadius: 9, padding: "12px 14px", marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: sel.color, marginBottom: 6, textTransform: "uppercase" }}>Results</div>
              <div style={{ fontSize: 13, color: C.dark, fontWeight: 600 }}>{sel.result}</div>
            </div>
            <PBtn onClick={() => { setSel(null); go("contact"); }} full>Start a Similar Project</PBtn>
          </Dlg>
        )}
      </div>
    </div>
  );
}
